import { combineReducers } from 'redux';
import GlobalErrorReducer from 'src/redux/Reducers/GlobalErrorReducer';
import AuthReducer from 'src/redux/Reducers/AuthReducer';
import TenantReducer from 'src/redux/Reducers/TenantReducer';
import OrganisationReducer from 'src/redux/Reducers/OrganisationReducer';
import VehicleTrackingReducer from 'src/redux/Reducers/VehicleTrackingReducer';
import SettingsReducer from 'src/redux/Reducers/SettingsReducer';
import eventLogSyncReducer from 'src/redux/Reducers/EventSyncLogReducer';
import productReducer from 'src/redux/Reducers/ProductReducer';
import breadcrumbReducer from 'src/redux/Reducers/BreadcrumbReducer';
import VehicleTrackingOutwardReducer from 'src/redux/Reducers/VehicleTrackingOutwardReducer';
import VehicleReducer from 'src/redux/Reducers/VehicleReducer';

const RootReducer = combineReducers({
  AuthReducer,
  GlobalErrorReducer,
  TenantReducer,
  OrganisationReducer,
  VehicleTrackingReducer,
  SettingsReducer,
  eventLogSyncReducer,
  productReducer,
  breadcrumbReducer,
  VehicleTrackingOutwardReducer,
  VehicleReducer,
});
export default RootReducer;
